// Описание параметров событий v2 (MOB-470). Одно описание даёт и данные для
// реестра (что уходит в DWH), и TS-тип для track() — разойтись им негде.

export type ParamSpec =
  | { readonly type: 'string', readonly required: boolean }
  | { readonly type: 'number', readonly required: boolean }
  | { readonly type: 'boolean', readonly required: boolean }
  | { readonly type: 'enum', readonly values: readonly string[], readonly required: boolean }

export interface EventDefinition {
  readonly description: string
  // Дата заведения события в реестр, YYYY-MM-DD.
  readonly since: string
  // Старые события, которые это событие заменяет, — пары для сверки в DWH.
  readonly replaces: readonly string[]
  readonly params: Readonly<Record<string, ParamSpec>>
}

export const required = {
  string: { type: 'string', required: true },
  number: { type: 'number', required: true }
} as const

export const optional = {
  string: { type: 'string', required: false },
  number: { type: 'number', required: false },
  boolean: { type: 'boolean', required: false }
} as const

export function requiredEnum<V extends readonly string[]> (values: V) {
  return { type: 'enum', values, required: true } as const
}

export function optionalEnum<V extends readonly string[]> (values: V) {
  return { type: 'enum', values, required: false } as const
}

// Проверяет форму реестра, не теряя литеральных типов.
export function defineRegistry<T extends Record<string, EventDefinition>> (registry: T): T {
  return registry
}

type ValueOf<S> =
  S extends { type: 'enum', values: readonly (infer V)[] } ? V
    : S extends { type: 'number' } ? number
      : S extends { type: 'boolean' } ? boolean
        : string

type RequiredKeys<P> = { [K in keyof P]: P[K] extends { required: true } ? K : never }[keyof P]
type OptionalKeys<P> = Exclude<keyof P, RequiredKeys<P>>

export type InferParams<P> =
  { [K in RequiredKeys<P>]: ValueOf<P[K]> } &
  { [K in OptionalKeys<P>]?: ValueOf<P[K]> }
